import React, { useEffect, useState } from "react";
import { walletTransactions } from "../../libs/dashboard";
import {
  buildReportFetchParams,
  refetchReportWithoutSearch,
  resetReportFilters,
} from "../../libs/reportFetchHelpers";
import { loggedInUsers } from "../../store/store";
import DataTable from "react-data-table-component";
import { formatNumber } from "../../libs/helper";
import { formatNumberAsCurrency } from "../../libs/decrypt";
import ReportToolbar from "../../components/ReportToolbar";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";

var CryptoJS = require("crypto-js");

const columns = [
  {
    name: "Ref",
    selector: (row) => row.reference,
    width: "200px",
    cell: (row) => (
      <div
        style={{
          wordBreak: "break-word",
          whiteSpace: "normal",
          textAlign: "left",
          padding: "3px",
        }}
      >
        {row.reference}
      </div>
    ),
  },
  {
    name: "Amount",
    selector: (row) => formatNumberAsCurrency(row.amount),
    width: "90px",
  },
  {
    name: "Type",
    selector: (row) => row.transactionType,
    sortable: true,
    width: "80px",
  },
  {
    name: "Narration",
    selector: (row) => row.narration,
  },
  {
    name: "Bal Before(₦)",
    selector: (row) => formatNumberAsCurrency(row.balanceBefore),
    width: "120px",
  },
  {
    name: "Bal After(₦)",
    selector: (row) => formatNumberAsCurrency(row.balanceAfter),
    width: "120px",
  },
  {
    name: "Created At",
    selector: (row) => row.createdAt,
    width: "150px",
    cell: (row) => (
      <div
        style={{
          wordBreak: "break-word",
          whiteSpace: "normal",
          textAlign: "left",
          padding: "3px",
        }}
      >
        {row.createdAt}
      </div>
    ),
  },
];

const WalletReport = () => {
  const { userdata } = loggedInUsers((state) => state.auth);
  var getUser = CryptoJS.AES.decrypt(
    userdata,
    process.env.REACT_APP_SOCKET_ENCRYPTION_KEY
  );
  var userD = JSON.parse(getUser.toString(CryptoJS.enc.Utf8));

  const todayDateString = dayjs().format("YYYY-MM-DD");

  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [filterDate, setFilterDate] = useState([
    todayDateString,
    todayDateString,
  ]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async (Fetch_values) => {
    setLoading(true);
    Fetch_values = Object.assign(Fetch_values, {
      email: userD?.email,
      bearerToken: userD?.bearerToken,
    });
    const getRec = await walletTransactions(Fetch_values);
    if (getRec) {
      setIsLoaded(true);
      setLoading(false);
      setItems(getRec.data);
      setTotalRows(getRec.headers["x-pagination-totalcount"]);
    } else {
      setIsLoaded(true);
      setError(error);
    }
  };

  const loadReport = (overrides = {}) => {
    fetchData(
      buildReportFetchParams({
        perPage,
        filterDate,
        searchTerm,
        overrides,
      })
    );
  };

  useEffect(() => {
    loadReport({ page: 1 });
  }, [perPage]);

  const onDateChange = (value, dateString) => {
    if (value) {
      setFilterDate(dateString);
      fetchData(
        buildReportFetchParams({
          page: 1,
          perPage,
          filterDate: dateString,
          searchTerm,
        })
      );
    } else {
      setFilterDate(null);
      fetchData(
        buildReportFetchParams({
          page: 1,
          perPage,
          filterDate: null,
          searchTerm,
        })
      );
    }
  };

  const handlePageChange = (page) => {
    loadReport({ page });
  };

  const handlePerRowsChange = async (newPerPage) => {
    setPerPage(newPerPage);
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (!value) {
      refetchReportWithoutSearch({ filterDate, perPage, fetchData });
    }
  };

  const handleSubmitSearch = () => {
    loadReport({ page: 1 });
  };

  const handleKeypress = (e) => {
    if (e.keyCode === 13) {
      if (e.target.value?.trim()) {
        handleSubmitSearch();
      } else {
        setSearchTerm("");
        refetchReportWithoutSearch({ filterDate, perPage, fetchData });
      }
    }
  };

  const handleResetFilters = () => {
    resetReportFilters({
      todayDateString,
      perPage,
      setSearchTerm,
      setFilterDate,
      fetchData,
    });
  };

  const dataRowStyles = {
    color: loading ? "gray" : "black",
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return <div>Loading...</div>;
  } else {
    return (
      <div className="App">
        <h1 className="text-xl font-semibold">Wallet Usage History</h1>
        <p className="text-xs font-semibold mb-2">
          <span className="text-xl font-semibold">
            {formatNumber(totalRows)}
          </span>{" "}
          Records Found
        </p>
        <ReportToolbar
          filterDate={filterDate}
          onDateChange={onDateChange}
          searchTerm={searchTerm}
          searchInputValue={searchTerm}
          onSearchChange={handleSearchChange}
          onSearchKeyDown={handleKeypress}
          onSubmitSearch={handleSubmitSearch}
          onResetFilters={handleResetFilters}
        />
        <DataTable
          columns={columns}
          data={items}
          fixedHeader
          pagination
          highlightOnHover="true"
          paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 50, 100]}
          paginationServer
          paginationTotalRows={totalRows}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
          customStyles={{
            rows: {
              style: dataRowStyles,
            },
          }}
        />
        <ToastContainer autoClose={3000} theme="colored" newestOnTop={true} />
      </div>
    );
  }
};

export default WalletReport;
